// Nudity classification constants

export const NUDITY_CLASSIFICATION = {
  SAFE: 0,
  HOT: 1,
  HARD: 2,
  UNIDENTIFIED: -1,
}

export const NUDITY_CLASSIFICATION_WITHOUT_HARD = {
  SAFE: NUDITY_CLASSIFICATION.SAFE,
  HOT: NUDITY_CLASSIFICATION.HOT,
  UNIDENTIFIED: NUDITY_CLASSIFICATION.UNIDENTIFIED,
}

export const NUDITY_CLASSIFICATION_TYPE = {
  SAFE: 'safe',
  HOT: 'hot',
  HARD: 'hard',
  UNIDENTIFIED: 'unidentified',
}

export const NUDITY_CLASSIFICATION_TYPE_MAP = {
  [NUDITY_CLASSIFICATION.SAFE]: NUDITY_CLASSIFICATION_TYPE.SAFE,
  [NUDITY_CLASSIFICATION.HOT]: NUDITY_CLASSIFICATION_TYPE.HOT,
  [NUDITY_CLASSIFICATION.HARD]: NUDITY_CLASSIFICATION_TYPE.HARD,
  [NUDITY_CLASSIFICATION.UNIDENTIFIED]: NUDITY_CLASSIFICATION_TYPE.UNIDENTIFIED,
}

export const NUDITY_CLASSIFICATION_TEXT_MAP = {
  [NUDITY_CLASSIFICATION.SAFE]: gettext('Safe'),
  [NUDITY_CLASSIFICATION.HOT]: gettext('Hot'),
  [NUDITY_CLASSIFICATION.HARD]: gettext('Hard'),
  [NUDITY_CLASSIFICATION.UNIDENTIFIED]: gettext('Unidentified photo'),
}

// Application flags and settings
export const APP_FLAGS = typeof window !== 'undefined' ? window.APP_FLAGS || {} : {}
export const AGE_VERIFICATION_REQUIREMENT_LEVELS = APP_FLAGS.ageVerificationRequirementLevels || {}
export const AGE_VERIFICATION_REQUIREMENT_LEVEL =
  APP_FLAGS.ageVerificationRequirementLevel || AGE_VERIFICATION_REQUIREMENT_LEVELS.POTENTIAL
export const NUDITY_HOT_BADGE_VARIANT = APP_FLAGS.nudityUiConfig?.hot_badge_variant || 'success'
export const NUDITY_HOT_WARNING_BADGE_ENABLED = NUDITY_HOT_BADGE_VARIANT === 'warning'
